export const Up: React.FC = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Basics / up">
        <path
          id="Stroke 169"
          d="M1 11L7.5 4L14 11"
          stroke="#1D1929"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
};
